import auth from 'src/router/auth'
import Receipt from '../Receipt'
import NewReceipt from '../NewReceipt'
import EditReceipt from '../EditReceipt'
import DetailReceipt from '../DetailReceipt'

export default [
  {
    path: '/receipt',
    name: 'receipt',
    component: Receipt,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/receipt/new',
    name: 'create-receipt',
    component: NewReceipt,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/receipt/:id/edit',
    name: 'edit-receipt',
    component: EditReceipt,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/receipt/:id',
    name: 'detail-receipt',
    component: DetailReceipt,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/receipt/routes/index.js